module.exports = __webpack_public_path__ + "static/ivan-e6e727e5b04c07f9594637f285ca5f1a.png";